/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plugins = exports.default = void 0;
var _factory = _interopRequireDefault(require("./factory"));
var _sortableColumns = _interopRequireDefault(require("./plugins/sortable-columns"));
var _filters = _interopRequireDefault(require("./plugins/filters"));
var _menus = _interopRequireDefault(require("./plugins/menus"));
var _cellSelection = _interopRequireDefault(require("./plugins/cell-selection"));
var plugins = [_sortableColumns.default, _filters.default, _menus.default, _cellSelection.default];
exports.plugins = plugins;
var ReactDataGrid = (0, _factory.default)({
  plugins: plugins
}, 'community');
var _default = ReactDataGrid;
exports.default = _default;